import { useSetRecoilState } from 'recoil';
import { drawerV2Atom } from '../stores/atom';
import { DrawerV2Inputs } from '../types/drawerV2';

export const useDrawerV2 = () => {
  const setDrawer = useSetRecoilState(drawerV2Atom);

  const openDrawer = (inputs: DrawerV2Inputs) => {
    setDrawer({
      isOpen: true,
      inputs,
      preventClose: false
    });
  };

  const closeDrawer = () => {
    setDrawer({
      isOpen: false,
      inputs: null,
      preventClose: false
    });
  };

  // Toggle whether the drawer may be dismissed by backdrop click / Escape.
  // Used by drawer content to guard against abandoning in-flight work.
  const setPreventClose = (preventClose: boolean) => {
    setDrawer((prev) => ({ ...prev, preventClose }));
  };

  return {
    openDrawer,
    closeDrawer,
    setPreventClose
  };
};
